module.exports = __webpack_public_path__ + "main-logged-out-58e5f421/super-ellipse-mask-cd22c3b8c137c9902b90787d046b531a.svg";